module.exports = __webpack_public_path__ + "static/img/yellow.fe32a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bodyparts/4/yellow.png
// module id = wRSX
// module chunks = 94